import { useConvertStablesDialog } from './logic/useConvertStablesDialog'
import { ConvertStablesView } from './views/ConvertStablesView'
import { SuccessView } from './views/SuccessView'
import { DialogContentSkeleton } from '@/features/dialogs/common/components/skeletons/DialogContentSkeleton'
import { withSuspense } from '@/ui/utils/withSuspense'

export interface ConvertStablesDialogContentContainerProps {
  proceedText: string
  closeDialog: () => void
}

function ConvertStablesDialogContentContainer({ proceedText, closeDialog }: ConvertStablesDialogContentContainerProps) {
  const { pageStatus, txOverview, form, formFields, actionsViewState } = useConvertStablesDialog()

  if (pageStatus.state === 'success') {
    return <SuccessView txOverview={txOverview} onProceed={closeDialog} proceedText={proceedText} />
  }

  return (
    <ConvertStablesView
      form={form}
      formFields={formFields}
      txOverview={txOverview}
      actionsViewState={actionsViewState}
    />
  )
}

const ConvertStablesDialogContentContainerWithSuspense = withSuspense(
  ConvertStablesDialogContentContainer,
  DialogContentSkeleton,
)
export { ConvertStablesDialogContentContainerWithSuspense as ConvertStablesDialogContentContainer }
